import { render } from "./AddFicherosLesion.vue?vue&type=template&id=6e6ef1c9"
import script from "./AddFicherosLesion.vue?vue&type=script&lang=js"
export * from "./AddFicherosLesion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__